/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["html{font-family:Helvetica,Arial,sans-serif}html.wf-active{font-family:Roboto}html body{background-color:#e7ebed;overflow-x:hidden}html cms-app{display:block;height:100%}html .gu-mirror{cursor:grabbing;cursor:-webkit-grabbing}.table-header-wrap{display:flex;flex-wrap:wrap;margin-bottom:.625rem}.box-shadow-container{box-shadow:0 1px 2px 0 rgba(69,90,100,.4);-webkit-box-shadow:0 1px 2px 0 rgba(69,90,100,.4);-moz-box-shadow:0 1px 2px 0 rgba(69,90,100,.4)}"];
export { styles as styles };
